import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-344cfe50"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "経営情報報告制度（損益計算書） 出力", -1))
const _hoisted_2 = {
  id: "soneki-keisan-form",
  class: "border border-primary p-3"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "登録", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "再集計", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-export" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "出力", -1))
const _hoisted_9 = { class: "mt-3" }
const _hoisted_10 = { class: "row align-items-center mt-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto col-form-label" }, "法人名", -1))
const _hoisted_12 = { class: "col-auto" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "col-auto col-form-label",
  style: {"margin-left":"220px"}
}, "医療法人整理番号", -1))
const _hoisted_14 = { class: "col-auto" }
const _hoisted_15 = { class: "row align-items-center mt-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto col-form-label" }, "所在地", -1))
const _hoisted_17 = { class: "col-auto" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "col-auto text-center mt-2 mb-1",
  style: {"font-size":"40px"}
}, "損  益  計  算  書", -1))
const _hoisted_19 = {
  class: "row justify-content-center mt-0",
  style: {"margin-top":"0"}
}
const _hoisted_20 = { class: "col-auto" }
const _hoisted_21 = ["value"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-right mb-0",
  style: {"width":"90%"}
}, "（単位：千円）", -1))
const _hoisted_23 = { class: "m-1 d-flex justify-content-center" }
const _hoisted_24 = { style: {"width":"80%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_soneki_keisan_export_item = _resolveComponent("soneki-keisan-export-item")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, { loading: _ctx.loading }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createVNode(_component_response_result_alert, {
        class: "mt-3",
        "is-succeed": _ctx.isSucceedRequest,
        "error-message": _ctx.requestError,
        onDismiss: _ctx.onDismissAlert
      }, null, 8, ["is-succeed", "error-message", "onDismiss"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_loading_button, {
          color: "primary",
          onClick: _ctx.onClickedRegister,
          loading: _ctx.loading,
          disabled: _ctx.hasError,
          class: "mr-2"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"]),
        _createVNode(_component_loading_button, {
          color: "primary",
          onClick: _ctx.onClickedRecalculate,
          loading: _ctx.loading,
          disabled: _ctx.hasError,
          class: "mr-5"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"]),
        _createVNode(_component_loading_button, {
          color: "primary",
          onClick: _ctx.onClickedExport,
          loading: _ctx.loading,
          disabled: _ctx.hasError
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control-sm align-middle",
                style: {"width":"400px","resize":"none"},
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.corporationName) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelText, _ctx.corporationName]
              ])
            ]),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control-sm align-middle text-center",
                style: {"width":"120px","resize":"none"},
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.medicalCorporationNumber) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelText, _ctx.medicalCorporationNumber]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control-sm align-middle",
                style: {"width":"600px","resize":"none"},
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.location) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelText, _ctx.location]
              ])
            ])
          ]),
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("textarea", {
                class: "form-control-sm text-center",
                style: {"width":"200px","resize":"none"},
                value: _ctx.accountingStartDate + ' ～ ' + _ctx.accountingEndDate,
                disabled: ""
              }, null, 8, _hoisted_21)
            ])
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_soneki_keisan_export_item, {
                "corporation-type": _ctx.corporationType,
                "soneki-items": _ctx.sonekiItems
              }, null, 8, ["corporation-type", "soneki-items"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}